import { FascicoloFull } from '../../../models/fascicolo/fascicolo-full';
import { FascicoloLight } from '../../../models/fascicolo/fascicolo-light';
import { PraticaBase } from '../../../models/pratica/pratica-base';

export class FascicoloGiudizialeAdapter extends FascicoloLight {
  praticaBase: PraticaBase;

  constructor(fascicoloFull: FascicoloFull) {
    super();
    this.id = fascicoloFull.id;
    this.idParent = fascicoloFull.idParent;
    this.tipoFascicolo = fascicoloFull.tipoFascicolo;
    this.stato = fascicoloFull.stato;
    this.dataDefinizione = fascicoloFull.dataDefinizione;
    this.motivoDefinizione = fascicoloFull.motivoDefinizione;
    this.definito = fascicoloFull.definito;
    this.grado = fascicoloFull.grado;
    this.posizione = fascicoloFull.posizione;
    this.vecchiaPosizione = fascicoloFull.vecchiaPosizione;
    this.flagProcessoTelematico = fascicoloFull.flagProcessoTelematico;
    this.flagFondoRischi = fascicoloFull.flagFondoRischi;
    this.dataVariazioneFondoRischi = fascicoloFull.dataVariazioneFondoRischi;
    this.natura = fascicoloFull.natura;
    this.dataInizioFascicolo = fascicoloFull.dataInizioFascicolo;
    this.note = fascicoloFull.note;
    this.registroFascicolo = fascicoloFull.registroFascicolo;
    this.praticaBase = fascicoloFull.praticaBase;
    this.riassunto = fascicoloFull.riassunto;
    this.intestazione = fascicoloFull.intestazione;
  }
}
